import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


gsap.registerPlugin(ScrollTrigger);

const stickyNav = document.querySelector('#jump-links');

if( stickyNav ){

    //jump link anchor pin
    ScrollTrigger.create({
        trigger: '.jump-link-trigger',
        start: "top top",
        onEnter: ({progress, direction, isActive}) => {
            let height = stickyNav.offsetHeight;
            //console.log(height);
            //console.log(stickyNav.previousElementSibling);
            stickyNav.previousElementSibling.style.height = height + 'px';
            stickyNav.classList.add('sticky');
        },
        onLeaveBack: ({progress, direction, isActive}) => {
            stickyNav.previousElementSibling.removeAttribute('style');
            stickyNav.classList.remove('sticky')
        },
        //markers: {startColor: "blue", endColor: "green", fontSize: "18px", fontWeight: "bold", indent: 20 }
    });

    let jumpLinks = gsap.utils.toArray("#jump-links a");

    jumpLinks.forEach( a => {
        let section = document.querySelector(a.getAttribute("href"));
        //console.log(section);

        ScrollTrigger.create({
            trigger: section,
            start: "top top+=250px",
            end: "bottom top+=250px",
            onToggle: self => {
                if(self.isActive){
                    jumpLinks.forEach(el => el.classList.remove("active"));
                    a.classList.add("active");
                }
                else{
                    a.classList.remove("active");
                }
            },
            //markers: {startColor: "purple", endColor: "orange", fontSize: "18px", fontWeight: "bold", indent: 20 }
        });
    });
}